import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, unref as _unref, vModelText as _vModelText, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "registration" }
const _hoisted_2 = { class: "terms page-content" }
const _hoisted_3 = { class: "page-title" }
const _hoisted_4 = { class: "text" }
const _hoisted_5 = { class: "radbox" }
const _hoisted_6 = { class: "radbox__text" }
const _hoisted_7 = { class: "radbox" }
const _hoisted_8 = { class: "radbox__text" }
const _hoisted_9 = ["placeholder"]
const _hoisted_10 = {
  key: 1,
  class: "input-error"
}
const _hoisted_11 = ["placeholder"]
const _hoisted_12 = {
  key: 3,
  class: "input-error"
}
const _hoisted_13 = ["placeholder"]
const _hoisted_14 = {
  key: 5,
  class: "input-error"
}
const _hoisted_15 = ["placeholder"]
const _hoisted_16 = {
  key: 1,
  class: "input-error"
}
const _hoisted_17 = ["placeholder"]
const _hoisted_18 = {
  key: 3,
  class: "input-error"
}
const _hoisted_19 = ["placeholder"]
const _hoisted_20 = {
  key: 5,
  class: "input-error"
}
const _hoisted_21 = {
  key: 3,
  class: "input-error"
}
const _hoisted_22 = ["placeholder"]
const _hoisted_23 = {
  key: 5,
  class: "input-error"
}
const _hoisted_24 = ["placeholder"]
const _hoisted_25 = {
  key: 7,
  class: "input-error"
}
const _hoisted_26 = ["placeholder"]
const _hoisted_27 = {
  key: 9,
  class: "input-error"
}

import FeedbackModal from "@/components/ui/FeedbackModal"
import { GuestChargingService } from "@/services/guest-charging-service"
import {
  maxLength,
  minLength,
  required,
  requiredIf,
  helpers
} from "@vuelidate/validators"
import config from "../config/index"
import PageHeader from "../components/ui/PageHeader.vue"
import ButtonComponent from "../components/ui/ButtonComponent.vue"
import CountrySelect from "@/components/ui/CountrySelect.vue"
import useVuelidate from "@vuelidate/core"
import { computed, onMounted, reactive, ref } from "vue"
import { useI18n } from "vue-i18n"
import { useRouter } from "vue-router"
import { useUserStore } from "../store/user"
import { storeToRefs } from "pinia"
import { stringNullify } from "@/utils/util"
import { AccountingInfo } from "@/models/common"
import { getCountryName } from "@/utils/getCountryName"
import { countries } from "@/models/countries"

// also has min-max length validation on formValidationParams

export default /*@__PURE__*/_defineComponent({
  __name: 'RegistrationPage',
  setup(__props) {

const TWO_TO_SIXTY_LETTERS_WITHOUT_DIGITS_AND_SOME_SPECIAL_CHARACTERS =
  helpers.regex(/^[^<>$%";*+?~:()=0-9]{2,60}$/i)
const TWO_TO_SIXTY_LETTERS_WITHOUT_SOME_SPECIAL_CHARACTERS = helpers.regex(
  /^[^<>$%";*+?~:=]{2,60}$/i
)
const FOUR_TO_TWELVE_LETTERS_OR_DIGITS_OR_HYPHENS =
  helpers.regex(/^[a-zA-Z0-9-]{4,12}$/i)
const FIVE_TO_150_LETTERS_WITHOUT_SOME_SPECIAL_CHARACTERS = helpers.regex(
  /^[^<>$%";*+?~:=]{5,150}$/i
)
const FIVE_TO_TWENTY_LETTERS_OR_DIGITS_OR_HYPHENS =
  helpers.regex(/^[a-zA-Z0-9-]{5,20}$/i)
const FIVE_TO_TWENTY_DIGITS = helpers.regex(/^[0-9]{5,20}$/i)
const FOUR_TO_FIFTEEN_DIGITS_WITH_OPTIONAL_PLUS_SIGN_AT_THE_FRONT =
  helpers.regex(/^\+?[0-9- ]{4,15}$/i)

const { t, locale } = useI18n()
const userStore = useUserStore()
const { acceptedTerms, email } = storeToRefs(userStore)
const router = useRouter()

const isPerson = ref(true)
const isFeedbackModalActive = ref(false)
const submitIsLoading = ref(false)
const feedbackSubTitle = ref(t("errors.defaultError.subTitle"))

const form = reactive<AccountingInfo>({
  firstName: "",
  lastName: "",
  address: "",
  city: "",
  postCode: "",
  country: "HU",
  companyName: "",
  taxNumber: "",
  groupCode: "",
  phoneNumber: ""
})

const formValidationParams = {
  firstName: {
    minLength: 2,
    maxLength: 60
  },
  lastName: {
    minLength: 2,
    maxLength: 60
  },
  address: {
    minLength: 2,
    maxLength: 60
  },
  city: {
    minLength: 2,
    maxLength: 60
  },
  postCode: {
    minLength: 4,
    maxLength: 12
  },
  country: {
    minLength: 2,
    maxLength: 60
  },
  companyName: {
    minLength: 5,
    maxLength: 150
  },
  taxNumber: {
    minLength: 5,
    maxLength: 20
  },
  groupCode: {
    minLength: 5,
    maxLength: 20
  },
  phoneNumber: {
    minLength: 4,
    maxLength: 15
  }
}

const withLength = (field: keyof typeof formValidationParams) => {
  const { minLength: min, maxLength: max } = formValidationParams[field]
  return { minLength: minLength(min), maxLength: maxLength(max) }
}

const rules = computed(() => {
  return {
    form: {
      firstName: {
        TWO_TO_SIXTY_LETTERS_WITHOUT_DIGITS_AND_SOME_SPECIAL_CHARACTERS,
        required: requiredIf(() => isPerson.value),
        ...withLength("firstName")
      },
      lastName: {
        TWO_TO_SIXTY_LETTERS_WITHOUT_DIGITS_AND_SOME_SPECIAL_CHARACTERS,
        required: requiredIf(() => isPerson.value),
        ...withLength("lastName")
      },
      address: {
        required,
        TWO_TO_SIXTY_LETTERS_WITHOUT_SOME_SPECIAL_CHARACTERS,
        ...withLength("address")
      },
      city: {
        required,
        TWO_TO_SIXTY_LETTERS_WITHOUT_DIGITS_AND_SOME_SPECIAL_CHARACTERS,
        ...withLength("city")
      },
      postCode: {
        regex: FOUR_TO_TWELVE_LETTERS_OR_DIGITS_OR_HYPHENS,
        required
      },
      country: {
        required
      },
      companyName: {
        requiredIf: requiredIf(() => !isPerson.value),
        FIVE_TO_150_LETTERS_WITHOUT_SOME_SPECIAL_CHARACTERS,
        ...withLength("companyName")
      },
      taxNumber: {
        requiredIf: requiredIf(() => !isPerson.value),
        regex: FIVE_TO_TWENTY_LETTERS_OR_DIGITS_OR_HYPHENS
      },
      groupCode: {
        FIVE_TO_TWENTY_DIGITS,
        ...withLength("groupCode")
      },
      phoneNumber: {
        FOUR_TO_FIFTEEN_DIGITS_WITH_OPTIONAL_PLUS_SIGN_AT_THE_FRONT,
        ...withLength("phoneNumber"),
        required: requiredIf(() => isPerson.value)
      }
    }
  }
})

const v$ = useVuelidate(rules, { form })

const onSubmit = async () => {
  if (v$.value.form.$invalid) {
    console.log("RegistrationPage onSubmit clicked, but the form is invalid!")
    return
  }

  Object.assign(form, stringNullify(form))

  const selectedCountry = countries.find(
    (country) => country.code === form.country
  )
  if (selectedCountry) {
    form.country = getCountryName(selectedCountry, locale.value)
  }

  submitIsLoading.value = true

  try {
    const { data } = await GuestChargingService.setAccountingInfo(form)
    window.location.href = data.simplePayUrl
  } catch (e: any) {
    console.error(e)
    feedbackSubTitle.value = t("errors.defaultError.subTitle", {
      errorMessage: e.message
    })
    isFeedbackModalActive.value = true
  } finally {
    submitIsLoading.value = false
  }
}

const handleFeedbackModalOkClick = () => {
  isFeedbackModalActive.value = false
}

onMounted(() => {
  if (!acceptedTerms.value) {
    console.log("User has not accepted the terms! Redirecting..")
    router.push("terms")
  }
  if (!email.value) {
    console.log("User has not given the e-mail address! Redirecting..")
    router.push("terms")
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(PageHeader),
    _createElementVNode("main", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.$t("registrationPage.title")), 1),
      _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t("registrationPage.subTitle")), 1),
      _createElementVNode("form", null, [
        _createElementVNode("label", _hoisted_5, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isPerson).value = $event)),
            value: true,
            class: "radbox__input",
            type: "radio"
          }, null, 512), [
            [_vModelRadio, isPerson.value]
          ]),
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t("registrationPage.form.person")), 1)
        ]),
        _createElementVNode("label", _hoisted_7, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((isPerson).value = $event)),
            value: false,
            class: "radbox__input",
            type: "radio"
          }, null, 512), [
            [_vModelRadio, isPerson.value]
          ]),
          _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t("registrationPage.form.legalPerson")), 1)
        ]),
        _cache[12] || (_cache[12] = _createElementVNode("hr", { class: "form-separator" }, null, -1)),
        (!isPerson.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (_unref(config).registrationFields.companyName)
                ? _withDirectives((_openBlock(), _createElementBlock("input", {
                    key: 0,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(v$).form.companyName.$model) = $event)),
                    class: _normalizeClass(["input", { error: _unref(v$).form.companyName.$error }]),
                    type: "text",
                    placeholder: _ctx.$t('registrationPage.form.companyName') + '*'
                  }, null, 10, _hoisted_9)), [
                    [_vModelText, _unref(v$).form.companyName.$model]
                  ])
                : _createCommentVNode("", true),
              (_unref(v$).form.companyName.$error)
                ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(_ctx.$t("registrationPage.validation.companyName", {
                minLength: formValidationParams.companyName.minLength,
                maxLength: formValidationParams.companyName.maxLength
              })), 1))
                : _createCommentVNode("", true),
              (_unref(config).registrationFields.taxNumber)
                ? _withDirectives((_openBlock(), _createElementBlock("input", {
                    key: 2,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(v$).form.taxNumber.$model) = $event)),
                    class: _normalizeClass(["input", { error: _unref(v$).form.taxNumber.$error }]),
                    type: "text",
                    placeholder: _ctx.$t('registrationPage.form.taxNumber') + '*'
                  }, null, 10, _hoisted_11)), [
                    [_vModelText, _unref(v$).form.taxNumber.$model]
                  ])
                : _createCommentVNode("", true),
              (_unref(v$).form.taxNumber.$error)
                ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(_ctx.$t("registrationPage.validation.taxNumber", {
                minLength: formValidationParams.taxNumber.minLength,
                maxLength: formValidationParams.taxNumber.maxLength
              })), 1))
                : _createCommentVNode("", true),
              (_unref(config).registrationFields.groupCode)
                ? _withDirectives((_openBlock(), _createElementBlock("input", {
                    key: 4,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(v$).form.groupCode.$model) = $event)),
                    class: _normalizeClass(["input", { error: _unref(v$).form.groupCode.$error }]),
                    type: "text",
                    placeholder: _ctx.$t('registrationPage.form.groupCode')
                  }, null, 10, _hoisted_13)), [
                    [_vModelText, _unref(v$).form.groupCode.$model]
                  ])
                : _createCommentVNode("", true),
              (_unref(v$).form.groupCode.$error)
                ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(_ctx.$t("registrationPage.validation.groupCode", {
                minLength: formValidationParams.groupCode.minLength,
                maxLength: formValidationParams.groupCode.maxLength
              })), 1))
                : _createCommentVNode("", true)
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (_unref(config).registrationFields.lastName)
                ? _withDirectives((_openBlock(), _createElementBlock("input", {
                    key: 0,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(v$).form.lastName.$model) = $event)),
                    class: _normalizeClass(["input", { error: _unref(v$).form.lastName.$error }]),
                    type: "text",
                    placeholder: _ctx.$t('registrationPage.form.lastName') + '*'
                  }, null, 10, _hoisted_15)), [
                    [_vModelText, _unref(v$).form.lastName.$model]
                  ])
                : _createCommentVNode("", true),
              (_unref(v$).form.lastName.$error)
                ? (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString(_ctx.$t("registrationPage.validation.lastName", {
                minLength: formValidationParams.lastName.minLength,
                maxLength: formValidationParams.lastName.maxLength
              })), 1))
                : _createCommentVNode("", true),
              (_unref(config).registrationFields.firstName)
                ? _withDirectives((_openBlock(), _createElementBlock("input", {
                    key: 2,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(v$).form.firstName.$model) = $event)),
                    class: _normalizeClass(["input", { error: _unref(v$).form.firstName.$error }]),
                    type: "text",
                    placeholder: _ctx.$t('registrationPage.form.firstName') + '*'
                  }, null, 10, _hoisted_17)), [
                    [_vModelText, _unref(v$).form.firstName.$model]
                  ])
                : _createCommentVNode("", true),
              (_unref(v$).form.firstName.$error)
                ? (_openBlock(), _createElementBlock("p", _hoisted_18, _toDisplayString(_ctx.$t("registrationPage.validation.firstName", {
                minLength: formValidationParams.firstName.minLength,
                maxLength: formValidationParams.firstName.maxLength
              })), 1))
                : _createCommentVNode("", true),
              (_unref(config).registrationFields.phoneNumber)
                ? _withDirectives((_openBlock(), _createElementBlock("input", {
                    key: 4,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(v$).form.phoneNumber.$model) = $event)),
                    class: _normalizeClass(["input", { error: _unref(v$).form.phoneNumber.$error }]),
                    type: "text",
                    placeholder: _ctx.$t('registrationPage.form.phoneNumber') + '*'
                  }, null, 10, _hoisted_19)), [
                    [_vModelText, _unref(v$).form.phoneNumber.$model]
                  ])
                : _createCommentVNode("", true),
              (_unref(v$).form.phoneNumber.$error)
                ? (_openBlock(), _createElementBlock("p", _hoisted_20, _toDisplayString(_ctx.$t("registrationPage.validation.phoneNumber", {
                minLength: formValidationParams.phoneNumber.minLength,
                maxLength: formValidationParams.phoneNumber.maxLength
              })), 1))
                : _createCommentVNode("", true)
            ], 64)),
        _cache[13] || (_cache[13] = _createElementVNode("hr", { class: "form-separator" }, null, -1)),
        (_unref(config).registrationFields.country)
          ? (_openBlock(), _createBlock(CountrySelect, {
              key: 2,
              modelValue: _unref(v$).form.country.$model as string,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(v$).form.country.$model as string) = $event)),
              error: _unref(v$).form.country.$error
            }, null, 8, ["modelValue", "error"]))
          : _createCommentVNode("", true),
        (_unref(v$).form.country.$error)
          ? (_openBlock(), _createElementBlock("p", _hoisted_21, _toDisplayString(_ctx.$t("registrationPage.validation.country")), 1))
          : _createCommentVNode("", true),
        (_unref(config).registrationFields.postCode)
          ? _withDirectives((_openBlock(), _createElementBlock("input", {
              key: 4,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(v$).form.postCode.$model) = $event)),
              class: _normalizeClass(["input", { error: _unref(v$).form.postCode.$error }]),
              type: "text",
              placeholder: _ctx.$t('registrationPage.form.postCode') + '*'
            }, null, 10, _hoisted_22)), [
              [_vModelText, _unref(v$).form.postCode.$model]
            ])
          : _createCommentVNode("", true),
        (_unref(v$).form.postCode.$error)
          ? (_openBlock(), _createElementBlock("p", _hoisted_23, _toDisplayString(_ctx.$t("registrationPage.validation.postCode", {
              minLength: formValidationParams.postCode.minLength,
              maxLength: formValidationParams.postCode.maxLength
            })), 1))
          : _createCommentVNode("", true),
        (_unref(config).registrationFields.city)
          ? _withDirectives((_openBlock(), _createElementBlock("input", {
              key: 6,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(v$).form.city.$model) = $event)),
              class: _normalizeClass(["input", { error: _unref(v$).form.city.$error }]),
              type: "text",
              placeholder: _ctx.$t('registrationPage.form.city') + '*'
            }, null, 10, _hoisted_24)), [
              [_vModelText, _unref(v$).form.city.$model]
            ])
          : _createCommentVNode("", true),
        (_unref(v$).form.city.$error)
          ? (_openBlock(), _createElementBlock("p", _hoisted_25, _toDisplayString(_ctx.$t("registrationPage.validation.city", {
              minLength: formValidationParams.city.minLength,
              maxLength: formValidationParams.city.maxLength
            })), 1))
          : _createCommentVNode("", true),
        (_unref(config).registrationFields.address)
          ? _withDirectives((_openBlock(), _createElementBlock("input", {
              key: 8,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(v$).form.address.$model) = $event)),
              class: _normalizeClass(["input", { error: _unref(v$).form.address.$error }]),
              type: "text",
              placeholder: _ctx.$t('registrationPage.form.address') + '*'
            }, null, 10, _hoisted_26)), [
              [_vModelText, _unref(v$).form.address.$model]
            ])
          : _createCommentVNode("", true),
        (_unref(v$).form.address.$error)
          ? (_openBlock(), _createElementBlock("p", _hoisted_27, _toDisplayString(_ctx.$t("registrationPage.validation.address", {
              minLength: formValidationParams.address.minLength,
              maxLength: formValidationParams.address.maxLength
            })), 1))
          : _createCommentVNode("", true),
        _createVNode(ButtonComponent, {
          block: "",
          primary: "",
          disabled: _unref(v$).form.$invalid,
          loading: submitIsLoading.value,
          onClick: onSubmit
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("registrationPage.enterBankCard")), 1)
          ]),
          _: 1
        }, 8, ["disabled", "loading"])
      ])
    ]),
    (isFeedbackModalActive.value)
      ? (_openBlock(), _createBlock(_unref(FeedbackModal), {
          key: 0,
          "main-title": _ctx.$t('errors.defaultError.mainTitle'),
          "sub-title": feedbackSubTitle.value,
          success: false,
          onConfirm: handleFeedbackModalOkClick
        }, null, 8, ["main-title", "sub-title"]))
      : _createCommentVNode("", true)
  ]))
}
}

})